/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import { LocalStorageService } from "./../../../services/shared/local-storage/local-storage.service";
import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Input,
  Inject,
} from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { SignInService } from "../authServices/signin.service";
import {
  UserRequest,
  SignInRequest,
} from "../models/userRequestResponse.interface";
import { DeviceDetectorService } from "ngx-device-detector";
import { SignupComponent } from "../signup/signup.component";
import {
  MatDialog,
  MatDialogConfig,
  MAT_DIALOG_DATA,
  MatDialogRef,
} from "@angular/material/dialog";
import { ForgotPasswordComponent } from "../forgot-password/forgot-password.component";
import { icons, isSRSMFlag } from "src/environments/config";
import { SlotService } from "src/app/services/slot/slot.service";

const EMAIL_CHECK_EXPRESSION: RegExp = /^[_a-zA-Z0-9]+(\.[_a-zA-Z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/;
const USER_PHONE_EXPRESSION: RegExp = /^[0-9]{10}$/;
@Component({
  selector: "app-signin",
  templateUrl: "./signin.component.html",
  styleUrls: ["./signin.component.scss"],
})
export class SigninComponent implements OnInit {
  // tslint:disable-next-line: max-line-length
  constructor(
    private router: Router,
    private deviceInfo: DeviceDetectorService,
    private signInService: SignInService,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private dialogSignIn: MatDialogRef<SigninComponent>,
    private localStorageService: LocalStorageService,
    public slotService: SlotService
  ) {}

  signInRequest: SignInRequest = {
    username: "",
    password: "",
    devicedescription: "",
    deviceid: "",
    devicename: "",
  };
  signInForm = new FormGroup({
    userDetails: new FormControl("", [
      Validators.required,
      Validators.pattern(
        "^[0-9]{10}$|^[_a-zA-Z0-9]+(.[_a-zA-Z0-9]+)*@[a-z0-9-]+(.[a-z0-9-]+)*(.[a-z]{2,4})$"
      ),
    ]),
    userPassword: new FormControl("", [
      Validators.required,
      Validators.minLength(8),
    ]),
  });
  isValidUser = true;
  errorMessage: string;
  userError: string;
  isTested = false;
  deviceID: any;
  deviceName: any;
  browser: any;
  currentURL: string;
  passwordType = "password";
  passwordImg = icons.whiteShopIcon.eyeSlash;
  passwordVisibility = false;

  get userDetails() {
    return this.signInForm.get("userDetails");
  }
  get userPassword() {
    return this.signInForm.get("userPassword");
  }

  // facebook: string;
  ngOnInit() {
    console.log("Entered on Tap");
    console.log(this.deviceInfo);
    console.log(this.dialogData);
    this.browser = this.deviceInfo.getDeviceInfo();
    this.deviceName = this.deviceInfo.device;
    // this.deviceID = this.uuid;
    console.log(this.browser);
    this.currentURL = this.router.url;
    console.log(this.currentURL);
  }

  dontHaveAnAccountFunction() {
    this.dialogSignIn.close();
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = false;
    dialogConfig.hasBackdrop = true;
    dialogConfig.maxWidth = "100vw";
    dialogConfig.width = "100vw";
    dialogConfig.panelClass = "override";
    dialogConfig.position = {
      top: "0",
      left: "0",
    };
    this.dialog.open(SignupComponent, dialogConfig);
  }
  forgotPasswordFunction() {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = false;
    dialogConfig.hasBackdrop = true;
    dialogConfig.maxWidth = "100vw";
    dialogConfig.width = "100vw";
    dialogConfig.panelClass = "override";
    dialogConfig.position = {
      top: "0",
      left: "0",
    };

    if (
      EMAIL_CHECK_EXPRESSION.test(this.userDetails.value) ||
      USER_PHONE_EXPRESSION.test(this.userDetails.value)
    ) {
      const request: any = {
        changePassword: false,
        forgotPassword: null,
        newPassword: null,
        otpGenerated: false,
        otpVerified: false,
        username: this.userDetails.value,
        verifyPassword: null,
      };
      if (EMAIL_CHECK_EXPRESSION.test(this.userDetails.value)) {
        this.signInService.sendUserDataFromSignInPage(request);
        request.email = this.userDetails.value;
        this.signInService.sendOTP(request).subscribe(
          (res: any) => {
            console.log(res);
            this.signInService.sendUserDataFromSignInPage(request);
            this.dialogSignIn.close();
            this.dialog.open(ForgotPasswordComponent, dialogConfig);
          },
          (err) => {
            console.log(err);

            this.userError = "Please Sign up to create new account";
          }
        );
      } else if (USER_PHONE_EXPRESSION.test(this.userDetails.value)) {
        request.phone = this.userDetails.value;
        this.signInService.sendUserDataFromSignInPage(request);
        this.signInService.sendOTP(request).subscribe(
          (res: any) => {
            console.log(res);
            this.signInService.sendUserDataFromSignInPage(request);
            this.dialogSignIn.close();
            this.dialog.open(ForgotPasswordComponent, dialogConfig);
          },
          (err) => {
            console.log(err);

            this.userError = "Please Sign up to create new account";
          }
        );
      }
    } else {
      console.log("error");

      this.userError = "Enter phone number or email";
    }
  }

  yourRatingFunction() {
    this.signInRequest.devicedescription = this.browser.userAgent;
    this.signInRequest.devicename = this.deviceName;
    //this.signInRequest.devicename = this.deviceID;

    if (EMAIL_CHECK_EXPRESSION.test(this.userDetails.value)) {
      if (this.userDetails.value && this.userPassword.value) {
        this.signInRequest.username = this.userDetails.value;
        this.signInRequest.password = this.userPassword.value;
        this.isTested = true;
      }
    } else if (USER_PHONE_EXPRESSION.test(this.userDetails.value)) {
      if (this.userDetails.value && this.userPassword.value) {
        this.signInRequest.username = this.userDetails.value;
        this.signInRequest.password = this.userPassword.value;
        this.isTested = true;
      }
    } else {
      this.isTested = false;
    }
    if (this.isTested) {
      this.signInService.signIn(this.signInRequest, isSRSMFlag.flag).subscribe(
        (json) => this.handleSignIn(json),
        (err) => this.handleSignInError(err)
      );
    } else {
      this.userError = "fill the fields correctly";
    }
  }

  handleSignIn(response: any) {
    if (response.error) {
      // this.router.navigateByUrl('/product/');
      this.isValidUser = false;
      this.errorMessage = response.error;
    } else {
      localStorage.setItem("userPic", response.user.profileImageURL);
      if (response.token && !response.company) {
        localStorage.setItem("nVipaniwhiteshopkey", response.token);
        this.router.navigateByUrl("/business-list");
      } else if (response.token && response.company) {
        localStorage.setItem("retailerToken", response.token);
        this.router.navigateByUrl("/stores");
      }
      if (response.isSupplier) {
        localStorage.setItem("isSupplier", JSON.stringify(response.isSupplier));
      }
      if (!sessionStorage.getItem("currentBusinessUnit") && response.company) {
        sessionStorage.setItem(
          "currentBusinessUnit",
          JSON.stringify(response.businessUnits.businessUnits[0].businessUnit)
        );
        this.slotService.currentBusinessUnit =
          response.businessUnits.businessUnits[0].businessUnit;
      }

      // console.log(response);
      // localStorage.setItem('nVipaniwhiteshopUser', response.user.username);
      // localStorage.setItem('userGroup', JSON.stringify(response.user.companies[0].userGroupType));
      // localStorage.setItem('user', JSON.stringify(response.user));
      this.localStorageService.setUserData(response);
      this.dialogSignIn.close(true);
    }
  }
  handleSignInError(response: any) {
    if (response.error) {
      // this.router.navigateByUrl('/product/');
      this.isValidUser = false;
      this.userError = response.error.message;
    } else {
      this.isValidUser = false;
      this.userError = "Something went wrong. Please try again.";
    }
  }

  togglePasswordVisibility() {
    if (this.passwordType === "text") {
      this.passwordType = "password";
      this.passwordVisibility = false;
      this.passwordImg = icons.whiteShopIcon.eyeSlash;
    } else {
      this.passwordType = "text";
      this.passwordVisibility = true;
      this.passwordImg = icons.whiteShopIcon.eye;
    }
  }

  validCredentials() {
    return (
      this.signInForm.controls.userDetails.valid &&
      this.signInForm.controls.userPassword.valid
    );
  }
}
